export default __webpack_public_path__ + "static/media/Home.8aa6ef22.png";